import { METERS_PER_UNIT } from 'ol/proj/Units';

const MIN_SCALE = 1000.0;
const INCHES_PER_METRE = 39.3700787;
const DPI = 25.4 / 0.28;

const toScale = (projection, resolution) => {
	const unit = projection.getUnits();	
	const scale = resolution * METERS_PER_UNIT[unit] * INCHES_PER_METRE * DPI;
    return scale;
}

const toResolution = (projection, scale) => {
	const unit = projection.getUnits();
    const resolution = scale / (METERS_PER_UNIT[unit] * INCHES_PER_METRE * DPI);
    return resolution;
}

const getMinResolution = (projection) => {
	return toResolution(projection, MIN_SCALE);
}


export {
	toScale, toResolution, MIN_SCALE, getMinResolution
}